// generic-use-form.ts
import { useEffect, useMemo } from "@adornis/functional-lit/stateful.js";
var generateUseForm = (FormClass) => {
  return (documentInput, options = {}, deps) => {
    const form = useMemo(() => {
      const formInstance = new FormClass(documentInput, options);
      return [formInstance, () => formInstance.disconnect()];
    }, []);
    useMemo(() => form.connect(), []);
    useEffect(() => form.update(documentInput, options), deps);
    return form;
  };
};
export {
  generateUseForm
};
